const GrayHorizontalDivider = () => {
  return (
    <div className="relative">
      <div
        className="absolute inset-0 flex items-center left-6 right-6 max-w-prose mx-auto"
        aria-hidden="true"
      >
        <div className="w-full border-t border-gray-400 "></div>
      </div>
    </div>
  );
};

export default GrayHorizontalDivider;
